module.exports = " <div class=Content> <app-leftcolumn> <left-menu></left-menu> </app-leftcolumn> <div class=bloc-center-row> <app-centercolumn> <router-view></router-view> </app-centercolumn> <app-widgetcentercolumn> </app-widgetcentercolumn> </div> <app-rightcolumn> </app-rightcolumn> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/views/AdministrationView.vue
// module id = 521
// module chunks = 1